/**
 * Strips numbering/lettering from lists.
 *
 * @param {string} string
 * */
const formatList = (string: string | undefined): string => {
    return string ? string.replace(/^([a-zA-Z0-9]{1,2}\.)/, '').trim() : '';
};

export default formatList;
